/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SessionActivityType {
    AFMRecordingSession = 'AFM Recording Session',
    WorkTime = 'Work Time',
    WorkTimeNight = 'Work Time - Night (+10%)',
    WorkTimeLateNight = 'Work Time - Late Night (+20%)',
    WorkTimeSaturday = 'Work Time - Saturday',
    WorkTimeSunday = 'Work Time - Sunday',
    WorkTimeHoliday = 'Work Time - Holiday',
    MealBreakfast = 'Meal - Breakfast',
    MealLunch = 'Meal - Lunch',
    MealDinner = 'Meal - Dinner',
    Fitting = 'Fitting',
    WardrobeChange = 'Wardrobe Change',
    HairAndMakeup = 'Hair And Makeup',
    TravelToLocation = 'Travel To Location',
    TravelToLocationAfterMidnight = 'Travel To Location (After Midnight)',
    TravelFromLocation = 'Travel From Location',
    TravelFromLocationAfterMidnight = 'Travel From Location (After Midnight)',
    Audition = 'Audition',
    Rehearsal = 'Rehearsal',
    LineMemorization = 'Line Memorization',
    AuditionScratchTrack = 'Audition Scratch Track',
    RecordingSession = 'Recording Session',
    VoiceOver = 'Voice Over',
    Demo = 'Demo',
    CreativeSession = 'Creative Session',
    CreativeAudition = 'Creative Audition',
}
